export default function NotesField({ value, onChange }) {
  return (
    <textarea
      name="notes"
      placeholder="Notes / Description"
      value={value}
      onChange={onChange}
      className="hobbli-notes-field"
    />
  );
}
